export default __webpack_public_path__ + "static/media/about-gallery.8a469264.jpg";